module.exports = __webpack_public_path__ + "img/manual-preenchimento.a13f6f63.svg";